import { useCallback } from 'react';
import { useTasksStore } from 'src/features/tasks/store/useTasksStore';

export const useTaskAccess = (taskId: string) => {
  const task = useTasksStore(useCallback((s) => s.tasks[taskId], [taskId]));

  return {
    isReadOnly: task?.access === 'view',
    isEditAccess: task?.access === 'edit',
    isFullAccess: task?.access === 'full' || (task?.access !== 'view' && task?.access !== 'edit'),
  };
};
